<div #pageTop>
  <!-- 印刷時のみ表示 -->
  <div class="problem-detail-show-print-only-wrapper" data-print-only *ngIf="printMenuType !== null">
    <app-problem-detail-frame-for-print
      [menuType]="printMenuType"
      [staticCommonData]="staticCommonData$ | async"
      [readableScienceProblems]="readableScienceProblemsForPrint$ | async"
      [readableEnglishProblems]="readableEnglishProblems$ | async"
      [readableNationalLanguageProblems]="readableNationalLanguageProblems$ | async"
      [readableJapaneseHistoryProblems]="readableJapaneseHistoryProblems$ | async"
      [readableWorldHistoryProblems]="readableWorldHistoryProblems$ | async"
      [paperMode]="true"
      [trialMode]="(signedInUser$ | async).isTrial"
      [subjectId]="subjectId"
      [isBToC]="false"
      [signedInUser]="signedInUser$ | async"
      [isFromBookmark]="true"
      [bookmarkListName]="bookmarkProblemListName"
      (dataReadyForPrint)="onPrintPreviewReady()"
    ></app-problem-detail-frame-for-print>
  </div>

  <!-- 通常表示（印刷時は非表示） -->
  <div data-no-print>
    <app-wrapper size="xl">
      <app-content-row>
        <app-button-location-back (backClick)="goBack()">一覧に戻る</app-button-location-back>
      </app-content-row>
    </app-wrapper>

    <app-wrapper size="xl" isFitWithSmallScreen="true" @enter *ngIf="firstPageInitialized$ | async; else loadingProgress">
      <app-content-row>
        <app-card-content [showSeparator]="false">
          <!-- ▼ 特種なヘッダー -->
          <app-card-content-head>
            <div class="flex flex-wrap gap-2 items-center grow ">
              <div class="flex gap-2 items-center grow mr-auto">
                <mat-icon class="text-primary shrink-0">list_alt</mat-icon>
                <span class="text-lg leading-[1.5]">{{ bookmarkProblemListName }}({{ subjectName }})</span>
                <span class="px-1.5 py-1 bg-primary text-white rounded-full text-sm leading-[1]">{{ totalBookmarkCount }}</span>
              </div>
              <div *ngIf="isPrivate">
                <span class="ml-auto text-xs shrink-0">オーナー：自分</span>
              </div>
              <div *ngIf="!isPrivate">
                <span class="ml-auto text-xs shrink-0">オーナー：{{ ownerName }}</span>
              </div>
            </div>
          </app-card-content-head>
          <!-- △ 特種なヘッダー -->
          <app-wrapper size="fluid">
            <app-content-row>
              <div class="flex gap-2">
                <div class="ml-2 mt-2">最終更新日: {{ lastUpdatedAt }}</div>
                <div class="ml-auto"><!-- spacer --></div>
                <div class="flex gap-2">
                  <button mat-flat-button class="bg-gray-30" [disabled]="totalBookmarkCount === 0" (click)="showPrintDialog('article')">
                    <mat-icon aria-hidden="true" class="text-primary">article</mat-icon>
                    問題をまとめて印刷
                  </button>
                  <button mat-flat-button class="bg-gray-30" [disabled]="totalBookmarkCount === 0" (click)="showPrintDialog('spellcheck')">
                    <mat-icon aria-hidden="true" class="text-primary">spellcheck</mat-icon>
                    研究・解答をまとめて印刷
                  </button>
                </div>

                <div>
                  <button
                    mat-flat-button
                    [matMenuTriggerFor]="mylistKebabMenu"
                    aria-label="action for mylist"
                    class="bg-gray-30 px-0 min-w-[40px]"
                  >
                    <mat-icon class="text-sub -mt-[3px]">more_vert</mat-icon>
                  </button>
                  <mat-menu #mylistKebabMenu="matMenu" xPosition="before">
                    <div *ngIf="isPrivate">
                      <button mat-menu-item (click)="updateBookmarkProblemList()">
                        <mat-icon class="mr-2">create</mat-icon>
                        <span class="font-semibold text-md">編集・公開設定</span>
                      </button>
                    </div>
                    <button mat-menu-item (click)="copyBookmarkProblemList()">
                      <mat-icon class="mr-2">content_copy</mat-icon>
                      <span class="font-semibold text-md">
                        {{ isPrivate ? '複製' : '自分のお気に入りリストへ複製' }}
                      </span>
                    </button>
                    <div *ngIf="isPrivate">
                      <button mat-menu-item (click)="deleteBookmarkProblemList()">
                        <mat-icon class="mr-2">delete_forever</mat-icon>
                        <span class="font-semibold text-md">削除</span>
                      </button>
                    </div>
                  </mat-menu>
                </div>
              </div>
            </app-content-row>
          </app-wrapper>

          <app-wrapper size="fluid" [isFitWithSmallScreen]="totalBookmarkCount !== 0">
            <app-content-row>
              <app-content-no-data *ngIf="totalBookmarkCount === 0">
                <span>お気に入りされている問題がありません</span>
              </app-content-no-data>
              <ng-container *ngIf="totalBookmarkCount != null && totalBookmarkCount !== 0">
                <div>
                  <!-- 英語の検索結果 -->
                  <div class="" *ngIf="subjectId === ENGLISH_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-english-problems
                        [readableEnglishProblems]="readableEnglishProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.ENGLISH"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-english-problems>
                    </div>
                  </div>

                  <!-- 数学の検索結果 -->
                  <div class="" *ngIf="subjectId === MATH_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readableMathProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.MATH"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 国語の検索結果 -->
                  <div class="" *ngIf="subjectId === NATIONAL_LANGUAGE_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-national-language-problems
                        [readableNationalLanguageProblems]="readableNationalLanguageProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.NATIONAL_LANGUAGE"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-national-language-problems>
                    </div>
                  </div>

                  <!-- 物理の検索結果 -->
                  <div class="" *ngIf="subjectId === PHYSICS_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readablePhysicsProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.PHYSICS"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 化学の検索結果 -->
                  <div class="" *ngIf="subjectId === CHEMISTRY_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readableChemistryProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.CHEMISTRY"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 生物の検索結果 -->
                  <div class="" *ngIf="subjectId === BIOLOGY_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readableBiologyProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.BIOLOGY"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 日本史の検索結果 -->
                  <div class="" *ngIf="subjectId === JAPANESE_HISTORY_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-history-problems
                        [readableHistoryProblems]="readableJapaneseHistoryProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.JAPANESE_HISTORY"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-history-problems>
                    </div>
                  </div>

                  <!-- 世界史の検索結果 -->
                  <div class="" *ngIf="subjectId === WORLD_HISTORY_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-history-problems
                        [readableHistoryProblems]="readableWorldHistoryProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.WORLD_HISTORY"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-history-problems>
                    </div>
                  </div>

                  <!-- 地理の検索結果 -->
                  <div class="" *ngIf="subjectId === GEOGRAPHY_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readableGeographyProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.GEOGRAPHY"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 政治・経済の検索結果 -->
                  <div class="" *ngIf="subjectId === POLITICAL_ECONOMY_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readablePoliticalEconomyProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.POLITICAL_ECONOMY"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 推薦・総合の検索結果 -->
                  <div class="" *ngIf="subjectId === SPECIAL_ADMISSIONS_SUBJECT_ID">
                    <div [@fadeInOut]="(bookmarkSearching$ | async) === false">
                      <app-science-problems
                        [readableScienceProblems]="readableSpecialAdmissionsProblems$ | async"
                        (problemClick)="showProblemDetail($event)"
                        (dropped)="onDragDropped($event)"
                        (totalProblemCount)="updateTotalProblemCount($event)"
                        [subjectId]="SubjectId.SPECIAL_ADMISSIONS"
                        [isTrial]="(signedInUser$ | async).isTrial"
                        [isDraggable]="isPrivate"
                        [disabled]="!isPrivate"
                        [bookmarkProblemListId]="bookmarkProblemListId"
                      ></app-science-problems>
                    </div>
                  </div>

                  <!-- 問題取得中のプログレス -->
                  <div class="progress-48" [@fadeInOut]="bookmarkSearching$ | async">
                    <mat-spinner [diameter]="48"></mat-spinner>
                  </div>

                  <div class="mt-4">
                    <!-- ページネーションは未分類のリストのみ-->
                    <!--
                  <app-paginator
                    [currentPage]="currentPage"
                    [totalItemCount]="totalBookmarkCount"
                    [pageSize]="paginationPageSize"
                    [windowSize]="paginationWindowSize"
                    (pageChange)="selectPage($event)"
                  ></app-paginator>
                  -->
                    <!-- ページネーションは未分類のリストのみ-->
                  </div>
                </div>
              </ng-container>
            </app-content-row>
          </app-wrapper>
        </app-card-content>
      </app-content-row>
    </app-wrapper>

    <ng-template #loadingProgress>
      <div class="progress-48">
        <mat-spinner [diameter]="48"></mat-spinner>
      </div>
    </ng-template>
  </div>
</div>
